export default {
    INIT_BASKET: function (state, data) {
        state.basket = data.basket;
        state.freeTransportLimit = data.freeTransportLimit;
        state.deliveryAndPaymentSelected = data.deliveryAndPaymentSelected;
        state.user = data.user;
    },
    UDPATE_BASKET: function (state, data) {
        state.basket = data.basket;
    },
    UPDATE_BASKET_PACK_NAME: function (state, data) {
        state.basket.itemPacks[data.uid].bedName = data.name;
    },
    LOADING_CONTENT: function (state, data) {
        state.loadingContent = data;
    },
    LOADING_CREDITS: function (state, data) {
        state.loadingCredits = data;
    },
    UPDATE_USER: function (state, data) {
        state.user = data;
    },
};
